/**
 * The global config object for the entire app
 * this object contains config data such as API urls and potentially any other configs
 */
const { REACT_APP_CONFIG_ENV } = process.env;
const config = {};

switch (REACT_APP_CONFIG_ENV) {
  case 'dev':
  case 'development': {
    config.env = 'dev';
    config.bocaAPIUrl = 'https://boca-api-staging.ihealthcareclouds.com/api/v2';
    config.bocaDashboardUrl = 'https://boca.ihealthcareclouds.com/';
    config.stripePublicKey = 'pk_test_ySVNnI0El8HeNgUeAehe4H30003SlwCeDt';
    break;
  }
  case 'prod':
  case 'production':
    config.env = 'production';
    config.bocaAPIUrl = 'https://api.ihealthcareclouds.com/api/v2';
    config.bocaDashboardUrl = 'https://ihealthcareclouds.com/';
    config.stripePublicKey = 'pk_live_Im5q52M9bQsk0sjMEEndskkH00qH9FQ9Nw';
    break;
  case 'local':
  default:
    // default to local if unspecified;
    config.env = 'local';
    config.bocaAPIUrl = 'http://localhost:3002/api/v2';
    config.bocaDashboardUrl = 'http://localhost:9002/';
    config.stripePublicKey = 'pk_test_ySVNnI0El8HeNgUeAehe4H30003SlwCeDt';
    break;
}

export default config;



// WEBPACK FOOTER //
// ./src/config/configureEnv.js